import { render, staticRenderFns } from "./TodoListForm.vue?vue&type=template&id=0e23a36a&scoped=true"
import script from "./TodoListForm.vue?vue&type=script&lang=js"
export * from "./TodoListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e23a36a",
  null
  
)

export default component.exports